import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { ENTREGADOR_ALTERAR_SCALE_TYPE } from 'gql/entregador';

export const useToggleTypeCollect = () => {
    const [toggleTypeCollect, { loading: loadingToogleTypeCollect }] = useMutation(
        ENTREGADOR_ALTERAR_SCALE_TYPE
    );
    const handleToogleTypeCollect = useCallback(
        ({ entregadorId, typeScale } : {
            entregadorId: string;
            typeScale: string;
        }) => {
            toggleTypeCollect({
                variables: { entregadorId, typeScale },
            });
        },
        [toggleTypeCollect]
    );
    return {
        handleToogleTypeCollect,
        loadingToogleTypeCollect,
    };
};
